import { Controller } from "@hotwired/stimulus"

// Le fond d'une couverture glisse plus lentement que la page.
//
// PAS `background-attachment: fixed`, qui ne s'applique qu'à un fond CSS — donc pas à une
// balise `<img>` — et que le moindre `contain` neutralise. Le projet de référence l'a
// abandonné pour cette raison. On déplace l'image nous-mêmes, à la fraction du défilement.
//
// `prefers-reduced-motion` est respecté : un mouvement qu'on n'a pas demandé peut donner
// la nausée, et une bannière n'a pas à imposer ça.
export default class extends Controller {
  static targets = ["media"]

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.onScroll = () => this.#place()
    // `passive` : ce contrôleur n'annule jamais le défilement, et le dire au navigateur lui
    // permet de ne pas attendre pour faire glisser la page.
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.#place()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  #place() {
    const frame = this.element.getBoundingClientRect()
    // Rien à faire tant que le cadre est hors du champ : le calcul serait perdu, et il a
    // lieu à chaque défilement.
    if (frame.bottom < 0 || frame.top > window.innerHeight) return

    // 15 % de la vitesse : assez pour que le regard le remarque, trop peu pour que
    // l'image se décolle de son cadre.
    const shift = (window.innerHeight - frame.top) * 0.15
    this.mediaTarget.style.transform = `translate3d(0, ${shift}px, 0)`
  }
}
